import Process from "../Process"
import { getStats } from "../../devHooks";

if(__DEV__) {
	var stats = getStats();
}

export default class EngineProcess {
	
	private process: Process<any>;
	
	private animationFrameId: number = 0;
	private previous: number = -1;
	private lag: number = 1000;
	
	private fps: number;
	private pauseOnFocusLost: boolean;
	private maximumDelta: number;
	
	private paused = 0;
	
	private onblur = () => this.pause();
	private onfocus = () => this.resume();
	
	constructor(process: Process<any>, { fps = 0, pauseOnFocusLost = false, maximumDelta = 0 } = {}) {
		
		this.process = process;
		this.pauseOnFocusLost = pauseOnFocusLost;
		
		if(__DEV__) {
			// pause/resume on F6
			let paused = false;
			let f6down = false
			window.addEventListener("keydown", function(e) {
				// if key is F6
				if(e.keyCode === 117) {
					e.preventDefault();
					
					if(f6down === false) {
						f6down = true;
						if(paused) {
							process.resume();
						} else {
							process.pause();
						}
						paused = !paused;
					}
				}
			});
			window.addEventListener("keyup", function(e) {
				if(e.keyCode === 117) {
					f6down = false;
				}
			});
		}
		
		this.fps = fps;
		if(this.pauseOnFocusLost) {
			window.addEventListener("blur", this.onblur);
			window.addEventListener("focus", this.onfocus);
		}
		this.maximumDelta = maximumDelta;
		
		this.start();
		
		this.process.getPromise(); // TODO solve without sideeffect
	}
	
	private start() {
		this.previous = -1;
		this.lag = 1000;
		
		this.animationFrameId = window.requestAnimationFrame(() => this.loop());
	}
	
	private loop() {
		
		if(__DEV__) {
			window.requestAnimationFrame(stats.begin);
		}
		
		var current = Date.now();
		if(this.previous === -1) {
			var elapsed = 0;
		} else {
			var elapsed = current - this.previous;
		}
		this.previous = current;
		
		if(this.maximumDelta !== 0 && elapsed >= this.maximumDelta * 1000) {
			elapsed = this.maximumDelta * 1000 | 0;
		}
		
		if(this.fps === 0) {
			
			window.requestAnimationFrame(() => Process.callStep(this.process, elapsed / 1000));

			this.animationFrameId = window.requestAnimationFrame(() => {
				Process.callFrame(this.process);
				this.loop();
			});
		
		} else {
			
			this.lag += elapsed * this.fps;
			
			var callRender = this.lag > 500;
			
			while(this.lag > 500) {
				window.requestAnimationFrame(() => Process.callStep(this.process, 1 / this.fps));
				
				this.lag -= 1000;
			}
			
			this.animationFrameId = window.requestAnimationFrame(() => {
				if(callRender) {
					Process.callFrame(this.process);
				} 
				this.loop();
			});
			
		}
		if(__DEV__) {
			window.requestAnimationFrame(stats.end);
		}
		
	}
	
	public pause() {
		if(this.paused === 0) {
			window.cancelAnimationFrame(this.animationFrameId);
		}
		this.paused++;
	}
	
	public resume() {
		this.paused--;
		if(this.paused === 0) {
			this.start();
		}
	}
	
	public destroy() {
		if(this.pauseOnFocusLost) {
			window.removeEventListener("blur", this.onblur);
			window.removeEventListener("focus", this.onfocus);
		}
		if(this.paused === 0) {	
			window.cancelAnimationFrame(this.animationFrameId);
		}
	}
	
}